<mat-sidenav-container
  class="sidenav-container"
  [ngClass]="{ 'bg-primary': darkModeService.isDarkModeOn() }"
  (backdropClick)="close('backdrop')"
>
  <mat-sidenav-content
    [attr.data-bs-theme]="darkModeService.darkModeSignal()"
    [ngClass]=""
  >
    <router-outlet></router-outlet>
  </mat-sidenav-content>

  <mat-sidenav
    #sidenav
    position="end"
    [autoFocus]="false"
    (keydown.escape)="sidenav.close()"
    disableClose
    class="position-fixed"
  >
    <i
      class="fa fa-2x fa-times"
      matRipple
      [matRippleUnbounded]="false"
      [matRippleCentered]="true"
      (click)="sidenav.close()"
    ></i>
    <ch-sidenav></ch-sidenav>
  </mat-sidenav>
</mat-sidenav-container>

<div class="loading-indicator" *ngIf="progressSpinnerStatus">
  <mat-spinner> </mat-spinner>
</div>
